import request from '@/utils/request'
const apiPath = '/lecturer/lecturer'
const lecturerApi = {
  /**
   * 新增【讲师管理】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【讲师管理】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【讲师管理】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【讲师管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/tee/${id}`)
  },
  /**
   * 删除单个【讲师管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  setIsRecommend(data) {
    return request.put(apiPath + '/tee/setIsRecommend', data)
  },
}
export default lecturerApi
